// extracted by mini-css-extract-plugin
export var textInput = "_lr-0";